import React from "react";
import data from "../../json/premiumFeatures.json";
import { Col, Container, Row, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./PremiumFeatures.scss";
import { 
  Code, FileCode, Clipboard, FileText, FlaskConical, 
  Database, ShieldCheck, ChartLine, RefreshCw, 
  GitBranch, Network, Map 
} from "lucide-react";

const iconMap = {
  faCode: Code,
  faFileCode: FileCode,
  faTasks: Clipboard,
  faFileAlt: FileText,
  faVial: FlaskConical,
  faDatabase: Database,
  faShieldAlt: ShieldCheck,
  faClipboardCheck: Clipboard,
  faChartLine: ChartLine,
  faSyncAlt: RefreshCw,
  faCodeBranch: GitBranch,
  faProjectDiagram: Network,
  faMap: Map
};

function PremiumFeatures() {
  // Sort the data by feature.publish
  const sortedData = Object.entries(data).sort(([, a], [, b]) => b.publish - a.publish);

  return (
    <div className="page-wrapper premium-features-page">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">Which premium services are you looking for?</h2>
              <div className="premium-features-wrapper">
                <Row>
                  {sortedData.map(([key, feature]) => {
                    const IconComponent = iconMap[feature.icon];
                    return (
                      <Col key={key} md={4} className="mb-4">
                        <Card className="features-card d-flex w-100 h-100 position-relative">
                          {feature.publish ? (
                            <Link to={`/${key}`} style={{ textDecoration: "none" }} className="d-flex w-100 h-100">
                              <Card.Body>
                                <div className={`icon-container ${feature.style}`}>
                                  <IconComponent size={32} color="#ffffff" strokeWidth={1} absoluteStrokeWidth />
                                </div>
                                <Card.Title>{feature.taskName}</Card.Title>
                                <Card.Text>{feature.description}</Card.Text>
                              </Card.Body>
                            </Link>
                          ) : (
                            <Card.Body>
                              <IconComponent className="card-icon mb-3" size={32} />
                              <Card.Title>{feature.taskName}</Card.Title>
                              <Card.Text>{feature.description}</Card.Text>
                              <div className="unpublished-overlay">
                                {/* Overlay content if needed */}
                              </div>
                            </Card.Body>
                          )}
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PremiumFeatures;